import { z } from "zod";
const primitives = z.union([
  z.undefined(),
  z.null(),
  z.boolean(),
  z.number(),
  z.string()
]);
const data = z.any();
const deviceId = z.string();
const deviceOverride = (value) => z.object({
  deviceId,
  value
});
const responsiveValue = (value) => z.array(deviceOverride(value));
const elementData = z.object({
  type: z.string(),
  key: z.string(),
  props: z.record(data)
});
const elementReference = z.object({
  type: z.literal("reference"),
  key: z.string(),
  value: z.string()
});
const element = z.union([elementData, elementReference]);
export {
  data,
  deviceId,
  deviceOverride,
  element,
  elementData,
  elementReference,
  responsiveValue
};
//# sourceMappingURL=schema.js.map